import { useState } from "react";
import Reveal from "@/components/base/Reveal";
import SectionHeading from "@/pages/home/components/SectionHeading";
import { faqs } from "@/mocks/homeData";

export default function Faq() {
  const [openId, setOpenId] = useState<string>(faqs[0]?.id ?? "");

  return (
    <section id="faq" className="w-full border-b border-background-200 bg-background-100">
      <div className="mx-auto w-full max-w-[1180px] px-4 py-14 md:px-6 md:py-20">
        <div className="grid grid-cols-1 gap-10 lg:grid-cols-12 lg:gap-14">
          <div className="lg:col-span-4">
            <Reveal>
              <SectionHeading
                eyebrow="FAQ"
                title="常见问题"
                description="关于海角黑料人物、身份与关系的几个高频疑问，先在这里给出明确回应。"
              />
            </Reveal>
            <Reveal delay={80}>
              <div className="mt-7 rounded-lg border border-background-200 bg-background-50 p-5">
                <div className="flex items-center gap-2 font-label text-xs text-secondary-700">
                  <i className="ri-question-answer-line text-sm text-secondary-500" />
                  还有别的问题？
                </div>
                <p className="mt-2 text-xs leading-relaxed text-foreground-600">
                  把疑问放到讨论区，整理时会一并归类到对应的人物脉络里。
                </p>
                <a
                  href="#discussion"
                  className="mt-3 inline-flex items-center gap-1 font-label text-xs text-primary-700 transition-colors duration-200 hover:text-primary-600"
                >
                  前往讨论区
                  <i className="ri-arrow-right-line text-sm" />
                </a>
              </div>
            </Reveal>
          </div>

          <div className="lg:col-span-8">
            <div className="flex flex-col gap-3">
              {faqs.map((item, index) => {
                const isOpen = openId === item.id;
                return (
                  <Reveal key={item.id} delay={index * 60}>
                    <div
                      className={`overflow-hidden rounded-lg border bg-background-50 transition-colors duration-300 ${
                        isOpen ? "border-primary-300" : "border-background-200"
                      }`}
                    >
                      <button
                        type="button"
                        onClick={() => setOpenId(isOpen ? "" : item.id)}
                        className="flex w-full cursor-pointer items-center justify-between gap-4 px-5 py-4 text-left md:px-6 md:py-5"
                      >
                        <span className="flex items-center gap-3">
                          <span className="font-label text-xs text-accent-600">
                            {String(index + 1).padStart(2, "0")}
                          </span>
                          <span className="font-heading text-base font-bold text-foreground-950 md:text-lg">
                            {item.q}
                          </span>
                        </span>
                        <span
                          className={`flex h-7 w-7 flex-none items-center justify-center rounded-full border transition-colors duration-300 ${
                            isOpen
                              ? "border-primary-300 bg-primary-100 text-primary-700"
                              : "border-background-300 text-foreground-500"
                          }`}
                        >
                          <i className={isOpen ? "ri-subtract-line text-base" : "ri-add-line text-base"} />
                        </span>
                      </button>
                      <div
                        className={`grid transition-all duration-300 ease-out ${
                          isOpen ? "grid-rows-[1fr] opacity-100" : "grid-rows-[0fr] opacity-0"
                        }`}
                      >
                        <div className="overflow-hidden">
                          <p className="border-t border-background-200 px-5 py-4 text-sm leading-relaxed text-foreground-600 md:px-6 md:pl-[52px]">
                            {item.a}
                          </p>
                        </div>
                      </div>
                    </div>
                  </Reveal>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}